/***
 *
 *   IN-APP PRICING
 *   Pricing table for your landing/pricing page
 *
 **********/

import React, { useState } from "react";
import { Card, CheckList, Badge, Grid, ClassHelper } from "components/lib";
import Style from "./in_app_pricing.tailwind.js";

const PLANS = [
  {
    name: "Starter",
    subheading: "For Individuals and small teams",
    monthlyPrice: 30,
    annualPrice: 27,
    annualTotal: 324,
    features: [
      "Includes 6 ID checks",
      "Single user login",
      "Templated onboarding forms",
      "Native, 2-way SaaS integration",
      "Branded ID check request emails",
      "Online support",
      "IDs from 230+ countries",
      "Cancel anytime",
    ],
    popular: false,
  },
  {
    name: "Professional",
    subheading: "For small to medium sized firms",
    monthlyPrice: 200,
    annualPrice: 180,
    annualTotal: 2160,
    features: [
      "Includes 44 ID checks",
      "5 user logins",
      "Templated onboarding forms",
      "Native, 2-way SaaS integration",
      "Branded ID check request emails",
      "Account Manager",
      "API / webhooks",
      "PDF report writeback",
      "IDs from 230+ countries",
      "Cancel anytime",
    ],
    popular: true,
  },
  {
    name: "Business",
    subheading: "For higher volume and complex requirements",
    monthlyPrice: 500,
    annualPrice: 450,
    annualTotal: 5400,
    features: [
      "Includes 125 ID checks",
      "Unlimited user logins",
      "Custom onboarding forms",
      "Native, 2-way SaaS integration",
      "Branded ID check request emails",
      "Account Manager",
      "Multiple brands / divisions",
      "Custom data retention policies",
      "IDs from 230+ countries",
      "Cancel anytime",
    ],
    popular: false,
  },
];

export function InAppPricing(props) {
  const [billing, setBilling] = useState("monthly");
  const isAnnual = billing === "annual";

  const monthlyStyle = ClassHelper(Style, {
    toggleBtn: true,
    toggleActive: !isAnnual,
  });

  const annualStyle = ClassHelper(Style, {
    toggleBtn: true,
    toggleActive: isAnnual,
  });

  return (
    <div>
      {/* Billing toggle */}
      <div className={Style.toggleWrap}>
        <div className={Style.toggleGroup}>
          <button onClick={() => setBilling("monthly")} className={monthlyStyle}>
            Monthly
          </button>
          <button onClick={() => setBilling("annual")} className={annualStyle}>
            Annual
            <span className={Style.saveBadge}>Save 10%</span>
          </button>
        </div>
      </div>

      {/* Pricing cards */}
      <Grid cols={3}>
        {PLANS.map((plan) => {
          const price = isAnnual ? plan.annualPrice : plan.monthlyPrice;
          const features = plan.features.map((f) => ({ name: f, checked: true }));

          return (
            <Card key={plan.name} shadow className={plan.popular ? Style.popularCard : ''}>
              {plan.popular && (
                <div className={Style.ribbonWrap}>
                  <Badge text="Popular" color="blue" />
                </div>
              )}

              <div className={Style.name}>{plan.name}</div>
              <p className={Style.subheading}>{plan.subheading}</p>

              <div className={Style.price}>
                <span className={Style.currency}>$</span>
                {price}
                <small className={Style.period}>USD / month</small>
              </div>

              {isAnnual && (
                <p className={Style.annualNote}>
                  Billed annually (${plan.annualTotal}/yr)
                </p>
              )}

              <CheckList items={features} />
            </Card>
          );
        })}
      </Grid>
    </div>
  );
}
